import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';

import rootReducer from '../reducers';
import * as sagas from '../sagas';
import { routerMiddleware } from './history';
import { initSagas } from '../../frontendUtils/redux';

const sagaMiddleware = createSagaMiddleware();

export default function configureStore(initialState: {} = {}) {
  // Middleware you want to use in production:
  const enhancer = applyMiddleware(
    sagaMiddleware,
    routerMiddleware,
  );

  const store = createStore(rootReducer, initialState, enhancer);

  // Extensions
  initSagas(sagas, sagaMiddleware);

  // Note: only Redux >= 3.1.0 supports passing enhancer as third argument.
  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  return store;
}
